import { useApolloClient, useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import AccordionContainer from "../common/accordion-container";
import { Label } from "reactstrap";
import Select from "../common/select/select";
import { ORG_VALUE_LISTS } from "../../graphql/valuelist-gql";
import { IValueListLight } from "../../types/valuelist";
import { GET_FRENCH_ITEMS, GET_FRENCH_ITEM_DETAIL, UPDATE_FRENCH_TRANS } from "../../graphql/french-gql";
import { IFrenchAdditionalInfo, IFrenchTaskInfo, IFrenchTaskInfoResponse } from "../../types/french";
import FrenchItemList from "./french-itemlist";
//import { notifySuccess } from "../../services/notification";
import { parseObject } from "../../utils/commons";
import FrenchItemDetail from "./french-item-detail";
import SpinnerOverlay from "../common/spinner/spinner";
import { useNavigate } from "react-router-dom";


export function FrenchQueue() {
    const client = useApolloClient()
    const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})
    const [catId, setCatId] = useState<any>()
    const [getFrenchItems,{loading:searchLoading,error:searchError}] = useLazyQuery<IFrenchTaskInfoResponse>(GET_FRENCH_ITEMS)
    const [getFrenchItemDetail,{loading:detailLoading, error: detailError}] = useLazyQuery<any>(GET_FRENCH_ITEM_DETAIL)
    const [items, setItems] = useState<IFrenchTaskInfo[]>([])
    const [addInfo, setAddInfo] = useState<IFrenchAdditionalInfo>()
    const [selectedTask, setSelectedTask] = useState<IFrenchTaskInfo>()
    const [selectChanged,setSelectChanged] = useState(true)
    const [refresh, setRefresh] =  useState(false)
    const [startPage, setStartPage] = useState<number>(1);
    const navigate = useNavigate();
    
    useEffect(() => {
        setItems([])
        setRefresh(false)
        // session state is used because there is a feature that allows navigating from the french queue page to the item (ex: organization)
        // then navigating back, and having that item already selected / loaded
        if (!catId) {
            try {
                const value = sessionStorage.getItem("catId")
                if (value) {
                    setCatId(JSON.parse(value))
                } else {
                    setCatId("")
                }
            } catch (error) {
                setCatId("")
            }
        }
        try {
            const value = sessionStorage.getItem("addInfo")
            if (value) {
                setAddInfo(JSON.parse(value))

            } else {
                setAddInfo(undefined)
            }
        } catch (error) {

            setAddInfo(undefined)
        }
        try {
            const value = sessionStorage.getItem("taskInfo")
            if (value) {
                const parsedValue = JSON.parse(value);
                setSelectedTask(parsedValue)

            } else {
                setSelectedTask(undefined)
            }
        } catch (error) {
            setSelectedTask(undefined)
        }

        if (catId) {
            getFrenchItems({
                variables: {
                    id: catId
                },
                fetchPolicy: 'network-only'
            }).then(response => {
                setSelectChanged(false)
                if (addInfo) {
                    scrollToDetails(100);
                }
                const responseItems = response.data?.getFrenchItemList ?? [];

                if (selectedTask) {
                    // we have a selected task, see if we can find its index
                    // if its not on the first page (index 0-9), we need to give the pagination control the index to start at
                    const index = responseItems.findIndex((item) => item.entityId === selectedTask.entityId && item.metaDataValueId === selectedTask.metaDataValueId);
                    const pageIndex = index < 10
                        ? 1
                        : Math.floor(index / 10) + 1;

                    setStartPage(pageIndex);
                }

                setItems(responseItems);
            })
        }
    }, [catId, refresh]);

    const onTypeChange = (event: any) => {
        setCatId(event.target.value)
        sessionStorage.setItem("catId", event.target.value)
        sessionStorage.removeItem("taskInfo")
        sessionStorage.removeItem("addInfo")
        setSelectChanged(true)
    }

    const handleSelected = (item: IFrenchTaskInfo | undefined) => {
        
        setSelectChanged(false)
        getFrenchItemDetail({
            variables: {
                id: catId,
                input: parseObject(item)
            },
            fetchPolicy: 'network-only'
        }).then(response => {
            setSelectedTask(item);
            setAddInfo(response.data?.getFrenchItemDetail);
            sessionStorage.setItem("addInfo", JSON.stringify(response.data?.getFrenchItemDetail))
            scrollToDetails(100);
        });
    }

    const handleRefresh = (item: boolean) =>{
        setRefresh(item);
    }

    const handleNavigation = (item: string) =>{
        sessionStorage.setItem("orgId", item)
        sessionStorage.setItem("taskInfo", JSON.stringify(selectedTask))
        sessionStorage.setItem("addInfo", JSON.stringify(addInfo))
        sessionStorage.setItem("catId", catId)
        navigate('/hierarchy')
    }

    function scrollToDetails(delay: number | undefined) {
        const detailContainer = document.getElementById('french_item_detail_container');
        if (detailContainer) {
            if (delay) {
                setTimeout(() => {
                    detailContainer.scrollIntoView({behavior: 'smooth'});
                }, delay);
            }
            detailContainer.scrollIntoView({behavior: 'smooth'});
        }
    }

    return (
        <>
            <h1 className="hidden-text">French Translation Queue</h1>
            <div className="mb-3">
            <AccordionContainer title="French Translation Queue" >
                <div className='row'>
                    <div className="col-1"><Label for="catetoryList">Show</Label></div>
                    <div className="col-4">
                        <Select id="catetoryList" name="catetoryList" value={catId} onChange={(event: any) => onTypeChange(event)} >
                            <option key={0} value={''}>Select an option </option>
                            {orgValueLists.frCategory.map((item: IValueListLight) => <option key={item.id} value={item.id}>{item.label}</option>)}
                        </Select>
                    </div>
                </div>
                {<FrenchItemList catId={catId} data={items} onSelect={handleSelected} selectChanged={selectChanged} startPage={startPage} refresh={refresh} />}
            </AccordionContainer>
            </div>
            {(detailLoading || searchLoading) && <SpinnerOverlay />}
            <div id="french_item_detail_container">
                {addInfo && selectedTask && <FrenchItemDetail taskInfo={selectedTask} addInfo={addInfo} catId={catId} refresh={handleRefresh} navigateTo={handleNavigation}></FrenchItemDetail>}
            </div>

        </>
    );
}

export default FrenchQueue;
